import React, { Component } from "react";
import "./ViewDeactivate.styles.scss";
// import { css } from "@emotion/core"
import BounceLoader from "react-spinners/BounceLoader";
import axios from "axios";
//import MomentUtils from "@date-io/moment";
import DateFnsUtils from "@date-io/date-fns";
//import moment from "moment";
import { format } from "date-fns";

import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";

class ViewDeactivate extends Component {
  state = {
    loading: false,
    showErr: false,

    resigning_date: new Date(),
  };

  handleDateChange = (date) => {
    this.setState({ resigning_date: date });
    //console.log(moment(date).toISOString())
  };

  handleFormSubmit = () => {
    this.setState({ loading: true });

    const { id } = this.props.data;

    const fd = new FormData();
    fd.append("mdo_id", id);
    fd.append(
      "resigning_date",
      //moment(this.state.resigning_date).format("yyyy-MM-dd").toString()
      format(new Date(this.state.resigning_date), "yyyy-MM-dd")
    );

    axios
      .post(
        `${process.env.REACT_APP_API_URL}/api/admin_panel/v1/deactivate-mdo`,
        fd,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      )
      .then((res) => {
        console.log(res);
        this.props.handleSave();
        setTimeout(() => {
          this.setState({
            loading: false,
            showErr: false,
          });
          this.props.viewMainOnClick();
        }, 2000);
      })
      .catch((err) => {
        this.setState({ loading: false, showErr: true });
        console.log(`error updating mdo ${err}`);
      });
  };

  render() {
    const { id } = this.props.data;

    return (
      <>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <div className="edit-main">
            <div className="edit-body">
              <div className="basic"></div>
            </div>

            <form>
              {/* <div className="group"> */}
              <KeyboardDatePicker
                autoOk
                variant="inline"
                inputVariant="outlined"
                label="Resigning Date"
                format="dd/MM/yyyy"
                value={this.state.resigning_date}
                InputAdornmentProps={{ position: "start" }}
                onChange={(date) => this.handleDateChange(date)}
                style={{ width: "400px", margin: "25px auto" }}
              />
              {/* </div> */}
            </form>

            <div className="footer-edit">
              <BounceLoader
                className="loader"
                color={"#e2136e"}
                size={20}
                loading={this.state.loading}
              />
              {this.state.showErr && (
                <div className="error-msg">
                  <span>
                    Something went wrong. Please re-select spot codes.
                  </span>
                </div>
              )}
              <button
                className="button--cancel"
                onClick={this.props.viewMainOnClick}
              >
                {" "}
                Cancel
              </button>
              <button className="button--save" onClick={this.handleFormSubmit}>
                {this.props.data.status === "Deactivated"
                  ? "Reactivate"
                  : "Save"}
              </button>
            </div>
          </div>
        </MuiPickersUtilsProvider>
      </>
    );
  }
}

export default ViewDeactivate;
